<template>
    <Paper :header="label">
        <div v-if="isLoading" class="pt-2 pb-1">
            <ListItemSkeleton v-for="i in 4" :key="i" mini :rows="3" />
        </div>
        <div v-else>
            <ListItem
                v-for="v in data"
                :id="v.id"
                :key="v.id"
                classes="py-3"
                :image="v.image"
                :header="v.header"
                :subheader="v.subheader"
                :subtitle="v.subtitle"
                icon="map-marker-alt"
                subtitle-icon="clock"
                :on-click="() => goTo(v)"
            />
        </div>
        <slot />
    </Paper>
</template>

<script>
import ListItem from './ListItem';
import ListItemSkeleton from '~/components/skeletons/ListItemSkeleton';

export default {
    components: { ListItem, ListItemSkeleton },
    props: {
        label: String,
        isLoading: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Array,
            default: () => [],
        },
        to: {
            type: String,
            required: true,
        },
        queryInfo: {
            type: Object,
            required: false,
        },
    },
    methods: {
        goTo(item) {
            // console.log('ID: ', item.id);
            const url = this.$props.to.concat(
                '/',
                item.id,
                item.requestId && item.eventId
                    ? `?RequestId=${item.requestId}&EventId=${item.eventId}`
                    : ''
            );
            this.$router.push(url);
        },
    },
};
</script>

<style scoped></style>
